<script lang="ts">
  let height = 0;
  export let hidden: boolean;
  export let disabled = false;
</script>

<div
  style="overflow: hidden; transition: {disabled ? 'none' : 'all .3s'}; height: {hidden
    ? 0
    : height}px;"
  aria-hidden={hidden ? 'true' : 'false'}
>
  {#if !hidden}
    <div>
      <div bind:offsetHeight={height}>
        <div style="display: flex; flex-direction: column;">
          <slot />
        </div>
      </div>
    </div>
  {/if}
</div>
